import React, { useState } from 'react';

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqData = [
        {
            question: "What services does Dari Investment Limited offer?",
            answer: "We offer complete construction, real estate, road construction, and general supply services across Nigeria, along with turnkey project management solutions."
        },
        {
            question: "Where are you located?",
            answer: "We operate nationwide, with major project footprints across several states. Our agricultural subsidiary, Dari Farms, is based in Yola, Adamawa State."
        },
        {
            question: "Who are your typical clients?",
            answer: "We work with a wide range of clients including government agencies, private developers, and commercial investors."
        },
        {
            question: "Do you handle design as well as construction?",
            answer: "Yes. Our in-house team includes architectural designers, engineers, and project managers who can take your project from concept to completion."
        },
        {
            question: "What makes Dari Investment different?",
            answer: "Our integrated approach, use of modern technology, skilled workforce, and commitment to quality"
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    // Add Tailwind CSS styles to the FAQ component
    return (
        <div id="faq" className="mx-auto p-4 w-[70%] md:w-[80%] lg:w-[70%]">
            <h2 className="text-2xl font-bold mb-6 text-center mt-10">Frequently Asked Questions</h2>
            {faqData.map((faq, index) => (
                <div key={index} className="mb-4">
                    <button 
                        className="w-full p-4 bg-white shadow-md rounded-lg flex justify-between items-center hover:bg-gray-50 transition-all duration-300"
                        onClick={() => toggleFAQ(index)}
                    >
                        <span className="font-medium">{faq.question}</span>
                        <span className="transform transition-transform duration-300 text-xl">
                            {activeIndex === index ? '−' : '+'}
                        </span>
                    </button>
                    <div 
                        className={`overflow-hidden transition-all duration-300 ${
                            activeIndex === index 
                                ? 'max-h-40 opacity-100 p-4' 
                                : 'max-h-0 opacity-0'
                        }`}
                    >
                        <p className="text-gray-600">{faq.answer}</p>
                    </div>
                </div>
            ))}
        </div>
    );

};

export default FAQ;